import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';

import './CollegeDistributeSteps.scss';

import CollegeDistributeFundList from '../CollegeDistributeFundList/CollegeDistributeFundList';
import CollegeDistributeReview from '../CollegeDistributeReview/CollegeDistributeReview';
import ProgressStep from '../../ProgressStep/ProgressStep';
import { moduleActions } from '../../../redux/modules';
import {
  isCustomerWebViewEnabled,
  isSalesforceRep,
} from '../../../redux/modules/authentication/authentication.module.selectors';
import { CANCEL_TRADE_CONFIRMATION_MODAL } from '../../../redux/modules/modals/modals.module';
import {
  getIsStep1NextButtonDisabled,
  getIsStep2DistributionSelectionsValid,
  getSellTransactionLookup,
} from '../../../redux/modules/sellTransaction/sellTransaction.selectors';
import AppTitle from '../../Shared/AppTitle/AppTitle';
import ErrorSlideIn from '../../Shared/ErrorSlideIn/ErrorSlideIn';
import DeliveryMethodForm from '../../Sell/DeliveryMethodForm/DeliveryMethodForm';
import DeliveryMethodChosen from '../../Sell/DeliveryMethodChosen/DeliveryMethodChosen';
import SellFundSummary from '../../Sell/SellFundSummary/SellFundSummary';
import {
  DELIVERY_MAIL_CHECK,
  DELIVERY_MAIL_CHECK_TO_SCHOOL,
  COLLEGE_DISTRIBUTE_PAYEE_OPTIONS,
  IAS_DELIVERY_MAIL_CHECK,
} from '../../../settings/settings';
import { getSelectedSchool } from 'src/redux/modules/schoolSelection';
import { getStudentDetails } from 'src/redux/modules/studentDetail';
import { scrollElementIntoFullView } from '../../../utils/dom-utils';
import { getRedemptionPayload } from '../../../redux/modules/executeRedemption/executeRedemption.selectors';

class CollegeDistributeSteps extends React.Component {
  constructor(props) {
    super(props);
    this.distributeStepValidation = this.distributeStepValidation.bind(this);
    this.onClickScroll = this.onClickScroll.bind(this);
  }

  distributeStepValidation() {
    const {
      actions: {
        getSellFundDistributionBeneficiaryAddresses,
        setValidationStart,
        setValidationFailed,
        setValidationSuccessful,
        validateSingleRedemption,
        validateDtsRedemption,
      },
      dispatch,
      redemptionPayload,
      sellDeliveryMethod: { deliveryMethod },
      sellTransactionLookup,
      studentDetail,
      selectedSchool,
    } = this.props;
    setValidationStart();

    // Call beneficiary address call if mail a check is selected
    const beneficiarySelected = Object.values(sellTransactionLookup).some(
      ({ payee }) => payee === COLLEGE_DISTRIBUTE_PAYEE_OPTIONS.BENEFICIARY
    );

    if (deliveryMethod === DELIVERY_MAIL_CHECK && beneficiarySelected) {
      const agreementIDsWithBeneSelected = Object.entries(
        sellTransactionLookup
      ).reduce((arr, [agreementID, selectedFund]) => {
        if (
          selectedFund.payee === COLLEGE_DISTRIBUTE_PAYEE_OPTIONS.BENEFICIARY
        ) {
          arr.push(agreementID);
        }
        return arr;
      }, []);
      getSellFundDistributionBeneficiaryAddresses(agreementIDsWithBeneSelected);
    }

    let transactionsValidationArray;

    if (deliveryMethod !== DELIVERY_MAIL_CHECK_TO_SCHOOL) {
      transactionsValidationArray = redemptionPayload.map((transaction) => {
        return dispatch(validateSingleRedemption(JSON.stringify(transaction)));
      });
      Promise.all(transactionsValidationArray).then(
        () => {
          setValidationSuccessful();
          this.setState({ shouldValidate: false });
        },
        (e) => {
          setValidationFailed(e);
        }
      );
    } else {
      const transactionRedeemRequestArray = redemptionPayload.map(
        (transaction) => {
          return {
            ...transaction,
            delivery: {
              enumerationID: 7,
              enumerationName: IAS_DELIVERY_MAIL_CHECK,
            },
          };
        }
      );
      transactionsValidationArray = dispatch(
        validateDtsRedemption(
          JSON.stringify({
            transactionRedeemRequest: transactionRedeemRequestArray,
            payeeDetail: {
              studentDetail: {
                studentID: studentDetail.student.id,
                studentName: {
                  firstName: studentDetail.student.firstName,
                  lastName: studentDetail.student.lastName,
                },
              },
              college: {
                name: selectedSchool.schoolName,
                ID: '',
              },
              payeeAddress: {
                '@Type': 'Address',
                addressLines: [
                  selectedSchool.addressLineOne,
                  selectedSchool.addressLineTwo,
                ],
                city: selectedSchool.city,
                state: selectedSchool.state,
                zipCode: selectedSchool.zip,
                zipExt: selectedSchool.zipExt,
                country: 'US',
              },
            },
          })
        )
      );
      Promise.all([transactionsValidationArray]).then(
        () => {
          setValidationSuccessful();
          this.setState({ shouldValidate: false });
        },
        (e) => {
          setValidationFailed(e);
        }
      );
    }
  }

  onClickScroll(step, element) {
    const {
      actions: { setProgress },
    } = this.props;
    setProgress(step);
    scrollElementIntoFullView(element, 15);
  }

  render() {
    const {
      isSalesforceRep,
      customerWebViewEnabled,
      actions,
      currentStep,
      executeRedemption: {
        redemption: { redemptionResultLoading },
        validation: {
          isValidRedemption,
          validationMessage: { message },
          validationResultLoaded,
          validationResultLoading,
        },
      },
      isStep1NextButtonDisabled,
      isStep2DistributionSelectionsValid,
      submitRedemption,
    } = this.props;
    const { openModal, setProgress } = actions;

    return (
      <form onSubmit={(e) => e.preventDefault()} className="animated fadeInUp">
        <AppTitle
          subtitle={`Request a distribution from your account and have the funding sent to an educational institution, the account holder, or the beneficiary.`}
          title="Distribute From Your 529 Plan"
        />

        <ProgressStep
          active={currentStep === 1}
          className="college-funding-source-step step1"
          complete={currentStep > 1}
          expanded
          nextButtonClassName="e2e-step1-verify-submit"
          nextButtonLabel={
            <span>
              <b>NEXT:</b> Select Portfolios & Amounts
            </span>
          }
          nextButtonDisabled={isStep1NextButtonDisabled}
          onNextClick={() => setProgress(2)}
          onCancelClick={() => openModal(CANCEL_TRADE_CONFIRMATION_MODAL)}
          showCancelLink={!(!customerWebViewEnabled && isSalesforceRep)}
          step={1}
          title={
            <span>
              Choose{' '}
              <span className="college-distribute-steps-expanded-title">
                {' '}
                your
              </span>{' '}
              delivery method
            </span>
          }
        >
          {currentStep === 1 ? (
            <DeliveryMethodForm />
          ) : (
            <DeliveryMethodChosen
              onEditClick={() => {
                this.onClickScroll(1, 'college-funding-source-step');
              }}
            />
          )}
        </ProgressStep>

        <ProgressStep
          active={currentStep === 2}
          className="college-distribute-step step2"
          complete={currentStep > 2}
          expanded
          nextButtonLabel={
            <span>
              <b>NEXT</b>: Review & Submit
            </span>
          }
          nextButtonDisabled={!isStep2DistributionSelectionsValid}
          nextButtonLoading={validationResultLoading}
          onNextClick={() => this.distributeStepValidation()}
          onCancelClick={() => openModal(CANCEL_TRADE_CONFIRMATION_MODAL)}
          showCancelLink={!(!customerWebViewEnabled && isSalesforceRep)}
          step={2}
          title={<span>Select your portfolio(s), amounts and payee</span>}
        >
          {currentStep === 2 ? (
            <CollegeDistributeFundList />
          ) : (
            <SellFundSummary
              clickable={isStep2DistributionSelectionsValid}
              onEditClick={() => {
                this.onClickScroll(2, 'college-distribute-step');
              }}
            />
          )}
        </ProgressStep>

        <ErrorSlideIn
          msg={message}
          show={validationResultLoaded && !isValidRedemption}
        />

        <ProgressStep
          active={currentStep === 3}
          className="review-step step3"
          expanded={currentStep === 3}
          nextButtonLabel="SUBMIT"
          onNextClick={submitRedemption}
          nextButtonDisabled={customerWebViewEnabled || redemptionResultLoading}
          onCancelClick={() => openModal(CANCEL_TRADE_CONFIRMATION_MODAL)}
          showCancelLink={!(!customerWebViewEnabled && isSalesforceRep)}
          step={3}
          title={
            <span>
              Review <span className="visible-xs-inline">& </span>
              <span className="hidden-xs">and </span> submit{' '}
              <span className="hidden-xs"> your distribution</span>
            </span>
          }
        >
          {currentStep === 3 ? <CollegeDistributeReview /> : null}
        </ProgressStep>
      </form>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    executeRedemption,
    progress: { currentStep },
    sellDeliveryMethod,
  } = state;

  return {
    currentStep,
    isSalesforceRep: isSalesforceRep(state),
    customerWebViewEnabled: isCustomerWebViewEnabled(state),
    executeRedemption,
    isStep1NextButtonDisabled: getIsStep1NextButtonDisabled(state),
    isStep2DistributionSelectionsValid:
      getIsStep2DistributionSelectionsValid(state),
    redemptionPayload: getRedemptionPayload(state),
    sellDeliveryMethod,
    sellTransactionLookup: getSellTransactionLookup(state),
    selectedSchool: getSelectedSchool(state),
    studentDetail: getStudentDetails(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(moduleActions, dispatch),
  dispatch,
  setProgress: (step) => {
    scrollElementIntoFullView(`step${step}`);
    dispatch(moduleActions.setProgress(step));
  },
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  CollegeDistributeSteps
);
